export default "__VITE_ASSET__f451c29b__"